/**
 * Deutsche Texte (Standardsprache).
 *
 * Aufbau: flache, punktnotierte Schluessel. Neue Sprachen werden angelegt,
 * indem diese Datei kopiert und uebersetzt wird (siehe en.ts); der Typ
 * `TranslationKeys` erzwingt Vollstaendigkeit zur Kompilierzeit.
 */
export const de = {
  'app.title': 'AudIT – Lizenzmanagement',
  'app.productSuffix': 'Lizenzmanagement',
  'app.subtitle': 'Zentrale Verwaltung und Auswertung der SaaS-Lizenzen',

  'nav.dashboard': 'Übersicht',
  'nav.countries': 'Länderreport',
  'nav.assignments': 'Zuweisungen',
  'nav.people': 'Personen',
  'nav.orphans': 'Verwaiste Lizenzen',
  'orphans.title': 'Verwaiste Lizenzen',
  'orphans.description': 'Lizenzen bei anderen Anbietern, deren Person im Verzeichnis nicht mehr aktiv ist. Ein Anbieter erfährt nichts davon, dass jemand das Unternehmen verlassen hat – der Platz läuft weiter, bis ihn jemand kündigt.',
  'orphans.count.one': '1 Lizenz',
  'orphans.count.other': '{count} Lizenzen',
  'orphans.reason.DIRECTORY_DISABLED': 'Konto deaktiviert',
  'orphans.reason.DIRECTORY_REMOVED': 'Konto entfernt',
  'orphans.reason.NOT_IN_DIRECTORY': 'kein Verzeichniskonto',
  'orphans.reason.NO_ADDRESS': 'keine Adresse',
  'orphans.reasonHint.DIRECTORY_DISABLED': 'Das Verzeichnis führt die Person noch, hat sie aber deaktiviert. Der klarste Fall: Die Lizenz kann gekündigt werden.',
  'orphans.reasonHint.DIRECTORY_REMOVED': 'Das Verzeichnis liefert dieses Konto nicht mehr – es wurde gelöscht. Die Lizenz kann gekündigt werden.',
  'orphans.reasonHint.NOT_IN_DIRECTORY': 'Keine Adresse dieser Person steht im Verzeichnis. Das kann eine längst ausgeschiedene Person sein – oder eine externe (Beratung, Agentur) oder eine Domäne, die im Verzeichnis anders geschrieben wird. Prüfen, nicht kündigen.',
  'orphans.reasonHint.NO_ADDRESS': 'Der Anbieter meldet zu diesem Platz keine Adresse. Damit ist keine Aussage über die Person möglich; das gehört an der Quelle behoben.',
  'orphans.actionable': 'eindeutig',
  'orphans.toCheck': 'zu prüfen',
  'orphans.kpi.actionable': 'Eindeutig verwaist',
  'orphans.kpi.actionableHint': 'Das Verzeichnis kennt die Person und führt sie nicht mehr – deaktiviert oder gelöscht.',
  'orphans.kpi.savings': 'Ersparnis / Monat',
  'orphans.kpi.savingsHint': 'Nur die eindeutigen Fälle und nur gepflegte Preise.',
  'orphans.kpi.toCheck': 'Zu prüfen',
  'orphans.kpi.toCheckHint': 'Kein Verzeichniskonto gefunden oder keine Adresse gemeldet. Externe Personen sehen genauso aus – hier gilt es hinzusehen.',
  'orphans.perYear': '{value} im Jahr',
  'orphans.noDirectory': 'Keine Verzeichnisquelle angebunden',
  'orphans.noDirectoryHint': 'Diese Auswertung vergleicht jede Lizenz mit dem Verzeichnis der Organisation (Microsoft 365). Solange keine solche Quelle angebunden ist, lässt sich nicht sagen, wer noch zum Unternehmen gehört – und eine leere Liste wäre keine Entwarnung.',
  'orphans.empty': 'Keine verwaisten Lizenzen gefunden.',
  'orphans.emptyHint': 'Jede Lizenz bei den anderen Anbietern gehört zu einer Person, die im Verzeichnis aktiv ist.',
  'orphans.excludeFree': 'Kostenlose Lizenzen ausblenden',
  'orphans.directoryBasis': 'Verglichen mit {providers} ({count} Konten).',
  'orphans.unpriced': '{count} ohne gepflegten Preis – sie fehlen in der Ersparnis.',
  'orphans.table.person': 'Person beim Anbieter',
  'orphans.table.provider': 'Lizenzquelle',
  'orphans.table.license': 'Lizenz',
  'orphans.table.cost': 'Kosten / Monat',
  'orphans.table.reason': 'Grund',
  'orphans.table.directory': 'Im Verzeichnis',
  'orphans.table.directoryLastSeen': 'zuletzt gemeldet {date}',
  'orphans.table.noDirectoryMatch': 'kein Treffer',
  'orphans.table.noAddress': 'keine Adresse gemeldet',
  'dashboard.orphans': 'Verwaiste Lizenzen',
  'dashboard.orphansHint': 'Lizenzen anderer Anbieter für Personen, die im Verzeichnis deaktiviert oder gelöscht sind.',
  'dashboard.action.orphans': 'Verwaiste Lizenzen ansehen',
  'nav.cart': 'Warenkorb',
  'nav.myRequests': 'Meine Anfragen',
  'nav.catalogRequests': 'Kataloganfragen',
  'cart.title': 'Warenkorb',
  'cart.description': 'Was hier liegt, geht als Anfrage an die IT. Daraus entsteht ein Ticket im Helpdesk – entschieden ist damit noch nichts.',
  'cart.add': 'In den Warenkorb',
  'cart.added': '„{name}“ liegt im Warenkorb.',
  'cart.inCart': 'Im Warenkorb',
  'cart.addNamed': '„{name}“ in den Warenkorb legen',
  'cart.inCartNamed': '„{name}“ liegt im Warenkorb',
  'cart.open': 'Warenkorb öffnen',
  'cart.empty': 'Der Warenkorb ist leer.',
  'cart.emptyHint': 'Im Katalog können Sie Hardware und Software hineinlegen und gemeinsam anfragen.',
  'cart.quantity': 'Menge',
  'cart.remove': 'Entfernen',
  'cart.clear': 'Warenkorb leeren',
  'cart.lineNote': 'Anmerkung zu dieser Position',
  'cart.orderFieldFallback': 'Zusatzangabe',
  'cart.orderFieldMissing': 'Bitte ausfüllen – ohne diese Angabe kann die IT nicht bestellen.',
  'cart.orderFieldMissingSummary': 'Bei mindestens einer Position fehlt eine Pflichtangabe. Bitte ergänzen Sie die markierten Felder.',
  'cart.note': 'Anmerkung für die IT',
  'cart.notePlaceholder': 'Wofür wird das gebraucht? Bis wann? Auf welche Kostenstelle?',
  'cart.submit': 'Anfrage absenden',
  'cart.submitting': 'Wird gesendet …',
  'cart.count.one': '1 Position',
  'cart.count.other': '{count} Positionen',
  'cart.localHint': 'Der Warenkorb liegt in diesem Browser. Er wandert nicht auf ein anderes Gerät mit und verschwindet, wenn Sie die Browserdaten löschen.',
  'cart.backToCatalog': 'Zurück zum Katalog',
  'softwareRequest.title': 'Neue Software beantragen',
  'softwareRequest.description': 'Etwas, das es im Katalog noch nicht gibt. Je genauer die Angaben, desto weniger Rückfragen – Pflicht sind nur Name und Zweck.',
  'softwareRequest.privacyNoticeTitle': 'Vor dem Ticket läuft eine Datenschutz-Vorprüfung.',
  'softwareRequest.privacyNotice': 'AudIT sucht öffentlich auffindbare Angaben zum Anbieter und lässt sie maschinell vorsortieren. Das Ergebnis ist ein Entwurf für die Datenschutzbeauftragten – keine Freigabe und keine Entscheidung. An die Prüfung gehen nur Angaben zur Software, nichts über Sie.',
  'softwareRequest.name': 'Name der Software',
  'softwareRequest.vendor': 'Anbieter',
  'softwareRequest.vendorUrl': 'Seite des Anbieters',
  'softwareRequest.vendorUrlHint': 'Hilft der Vorprüfung, die richtige Software zu finden – viele Namen gibt es mehrfach.',
  'softwareRequest.purpose': 'Wofür wird sie gebraucht?',
  'softwareRequest.purposeHint': 'Welche Aufgabe soll sie lösen, und wer arbeitet damit? Die Angabe, nach der am häufigsten zurückgefragt wird.',
  'softwareRequest.alternatives': 'Geprüfte Alternativen',
  'softwareRequest.alternativesHint': 'Was haben Sie sich angesehen, und warum reicht das Vorhandene nicht?',
  'softwareRequest.userCount': 'Wie viele Personen?',
  'softwareRequest.neededBy': 'Benötigt bis',
  'softwareRequest.cost': 'Geschätzte Kosten',
  'softwareRequest.costHint': 'Je Monat, falls bekannt. Eine grobe Schätzung ist besser als nichts.',
  'softwareRequest.currency': 'Währung',
  'softwareRequest.dataHeading': 'Daten',
  'softwareRequest.hostingHeading': 'Betrieb',
  'softwareRequest.hostingHint': 'Diese drei Angaben kennen die wenigsten – „Weiß ich nicht“ ist völlig in Ordnung. Die Vorprüfung versucht den Rest selbst herauszufinden und sagt, was sie belegen konnte und was nicht.',
  'softwareRequest.hostingModel': 'Wo läuft die Software?',
  'softwareRequest.hostingModel.UNKNOWN': 'Weiß ich nicht',
  'softwareRequest.hostingModel.SAAS': 'Beim Anbieter (Cloud/SaaS)',
  'softwareRequest.hostingModel.ON_PREMISES': 'Bei uns im Rechenzentrum',
  'softwareRequest.hostingModel.HYBRID': 'Gemischt',
  'softwareRequest.hostingRegion': 'In welcher Region liegen die Daten?',
  'softwareRequest.hostingRegionHint': 'Wichtigste Angabe für den Datenschutz: Außerhalb der EU gelten zusätzliche Anforderungen.',
  'softwareRequest.hostingRegion.UNKNOWN': 'Weiß ich nicht',
  'softwareRequest.hostingRegion.GERMANY': 'Deutschland',
  'softwareRequest.hostingRegion.EU': 'EU/EWR',
  'softwareRequest.hostingRegion.USA': 'USA',
  'softwareRequest.hostingRegion.OTHER': 'Anderswo oder mehrere Regionen',
  'softwareRequest.ssoEntra': 'Anmeldung über den Firmen-Account möglich?',
  'softwareRequest.ssoEntraHint': 'Microsoft Entra ID, also dieselbe Anmeldung wie hier. Spart ein eigenes Kennwort – und beim Austritt ein zweites Abschaltverfahren.',
  'softwareRequest.sso.UNKNOWN': 'Weiß ich nicht',
  'softwareRequest.sso.YES': 'Ja',
  'softwareRequest.sso.NO': 'Nein',
  'softwareRequest.dataHint': 'Diese Angaben entscheiden, wie aufwendig die Prüfung wird. „Weiß nicht“ ist eine zulässige Antwort – geraten hilft niemandem.',
  'softwareRequest.personalData': 'Werden personenbezogene Daten verarbeitet?',
  'softwareRequest.personalData.YES': 'Ja',
  'softwareRequest.personalData.NO': 'Nein',
  'softwareRequest.personalData.UNKNOWN': 'Weiß ich nicht',
  'softwareRequest.dataCategories': 'Welche Daten?',
  'softwareRequest.dataCategoriesHint': 'Zum Beispiel: Name, dienstliche E-Mail, Telefonnummer, Kundendaten.',
  'softwareRequest.dataSubjects': 'Von wem?',
  'softwareRequest.dataSubjectsHint': 'Zum Beispiel: Beschäftigte, Kundschaft, Lieferanten, Bewerbende.',
  'softwareRequest.note': 'Weitere Anmerkungen',
  'softwareRequest.submit': 'Antrag absenden',
  'softwareRequest.sending': 'Wird geprüft und gesendet …',
  'softwareRequest.submitHint': 'Die Vorprüfung dauert einen Moment. Absenden ist keine Genehmigung.',
  'softwareRequest.noPermission': 'Für Anträge fehlt Ihnen die Berechtigung. Wenden Sie sich an die IT.',
  'softwareRequest.navNew': 'Neue Software beantragen',
  'userRequest.navNew': 'Userantrag',
  'todos.label': 'Offene Aufgaben',
  'todos.labelCount': '{count} offene Aufgaben',
  'todos.none': 'Nichts zu tun.',
  'todos.approvals.one': 'Eine Freigabe wartet auf Sie',
  'todos.approvals.other': '{count} Freigaben warten auf Sie',
  'todos.failedRequests.one': 'Eine Anfrage ohne Ticket – erneut einreichen',
  'todos.failedRequests.other': '{count} Anfragen ohne Ticket – erneut einreichen',
  'userRequest.title': 'Userantrag',
  'userRequest.description': 'Für den Eintritt einer Person: Zugänge, Berechtigungen und Übergabe. Aus dem Antrag entsteht ein Ticket bei der IT.',
  'userRequest.personSearch': 'Name oder E-Mail-Adresse eingeben …',
  'userRequest.choose': 'Bitte auswählen',
  'userRequest.required': 'Bitte ausfüllen.',
  'userRequest.missingSummary': 'Es fehlen noch {count} Pflichtangaben. Die Felder sind markiert.',
  'userRequest.submit': 'Antrag absenden',
  'userRequest.submitHint': 'Der Antrag wird gespeichert und geht als Ticket an die IT.',
  'userRequest.sentTitle': 'Antrag {number} für {name} ist eingegangen.',
  'userRequest.another': 'Weiteren Antrag stellen',
  'userRequest.myHeading': 'Useranträge',
  'userRequest.firstWorkday': 'erster Arbeitstag {date}',
  'userRequest.showAnswers': 'Angaben anzeigen',
  'wizard.overview': 'Ihr Antrag',
  'wizard.stepOf': 'Schritt {current} von {total}',
  'wizard.back': 'Zurück',
  'wizard.next': 'Weiter',
  'wizard.review': 'Prüfen & absenden',
  'wizard.edit': 'Ändern',
  'wizard.here': 'Sie sind hier',
  'wizard.done': 'Vollständig',
  'wizard.empty': 'keine Angabe',
  'wizard.open.one': 'Eine Pflichtangabe fehlt',
  'wizard.open.other': '{count} Pflichtangaben fehlen',
  'wizard.blocked.one': 'Auf dieser Seite fehlt noch eine Pflichtangabe. Das Feld ist markiert.',
  'wizard.blocked.other': 'Auf dieser Seite fehlen noch {count} Pflichtangaben. Die Felder sind markiert.',
  'userRequest.reviewHint': 'Alles noch einmal im Überblick – so landet es im Ticket. Über „Ändern“ kommen Sie zur jeweiligen Seite zurück.',
  'softwareRequest.step.software': 'Software',
  'softwareRequest.step.softwareHint': 'Um welche Software geht es? Der Name genügt – Anbieter und Seite helfen der Vorprüfung, die richtige zu finden.',
  'softwareRequest.step.need': 'Zweck & Bedarf',
  'softwareRequest.step.needHint': 'Wofür, für wen und ab wann. Der Zweck ist die Angabe, nach der am häufigsten zurückgefragt wird.',
  'softwareRequest.reviewHint': 'Alles noch einmal im Überblick. Über „Ändern“ kommen Sie zur jeweiligen Seite zurück.',
  'softwareRequest.myHeading': 'Anträge auf neue Software',
  'softwareRequest.assessment': 'Datenschutz-Vorprüfung',
  'softwareRequest.assessmentDraft': 'Maschinell erstellter Entwurf – keine Freigabe, keine Rechtsberatung.',
  'softwareRequest.assessmentSources': 'Quellen',
  'softwareRequest.assessmentMissing': 'Keine Vorprüfung vorhanden.',
  'softwareRequest.assessmentRunning': 'Die Vorprüfung läuft. Sie dauert ein bis zwei Minuten; danach entsteht das Ticket.',
  'softwareRequest.sentQueued': 'Die Vorprüfung läuft jetzt im Hintergrund – sie dauert ein bis zwei Minuten. Danach entsteht das Ticket, und Sie finden es unter „Meine Anfragen“.',
  'softwareRequest.assessmentRetry': 'Vorprüfung wiederholen',
  'softwareRequest.risk.LOW': 'geringes Risiko',
  'softwareRequest.risk.MEDIUM': 'mittleres Risiko',
  'softwareRequest.risk.HIGH': 'hohes Risiko',
  'softwareRequest.risk.UNKNOWN': 'nicht einschätzbar',
  'softwareRequest.catalogHint': 'Nicht gefunden, was Sie brauchen?',
  'request.sentTitle': 'Anfrage {number} ist eingegangen',
  'request.sentWithTicket': 'Daraus ist das Ticket {ticket} geworden. Alles Weitere läuft über dieses Ticket.',
  'request.sentWithoutTicket': 'Ihre Anfrage ist gespeichert. Ein Ticket konnte noch nicht angelegt werden – die IT sieht die Anfrage trotzdem und kümmert sich darum.',
  'request.openTicket': 'Ticket öffnen',
  'request.toMyRequests': 'Zu meinen Anfragen',
  'requests.title': 'Meine Anfragen',
  'requests.description': 'Was Sie über den Katalog angefragt haben – und was daraus geworden ist.',
  'requests.empty': 'Sie haben noch nichts angefragt.',
  'requests.emptyHint': 'Im Katalog können Sie Hardware und Software in den Warenkorb legen und anfragen.',
  'requests.number': 'Anfrage {number}',
  'requests.status.PENDING': 'in Arbeit',
  'requests.status.SUBMITTED': 'als Ticket angelegt',
  'requests.status.FAILED': 'noch kein Ticket',
  'requests.status.CANCELLED': 'zurückgezogen',
  'requests.statusHint.PENDING': 'Die Anfrage ist gespeichert; das Ticket entsteht gleich.',
  'requests.statusHint.SUBMITTED': 'Alles Weitere läuft über das Ticket.',
  'requests.statusHint.FAILED': 'Die Anfrage ist gespeichert, ein Ticket konnte noch nicht angelegt werden. Die IT sieht sie trotzdem.',
  'requests.statusHint.CANCELLED': 'Sie haben diese Anfrage zurückgezogen.',
  'requests.status.AWAITING_APPROVAL': 'wartet auf Freigabe',
  'requests.status.REJECTED': 'abgelehnt',
  'requests.statusHint.AWAITING_APPROVAL': 'Die Bestellung liegt bei der freigebenden Person. Erst danach entsteht ein Ticket bei der IT.',
  'requests.statusHint.REJECTED': 'Die Bestellung wurde abgelehnt. Es ist kein Ticket entstanden.',
  'requests.approver': 'Freigabe durch',
  'approvals.title': 'Freigaben',
  'approvals.description': 'Bestellungen, die auf Ihre Freigabe warten. Erst mit der Freigabe entsteht ein Ticket bei der IT.',
  'approvals.empty': 'Nichts zu entscheiden.',
  'approvals.emptyHint': 'Hier erscheinen Bestellungen, bei denen Sie als freigebende Person benannt wurden.',
  'approvals.approve': 'Freigeben',
  'approvals.reject': 'Ablehnen',
  'approvals.note': 'Anmerkung (bei einer Ablehnung bitte begründen)',
  'approvals.approved': 'Freigegeben. Das Ticket wurde angelegt: {ticket}',
  'approvals.approvedNoTicket': 'Freigegeben. Das Ticket konnte noch nicht angelegt werden – die IT sieht die Bestellung trotzdem.',
  'approvals.rejected': 'Abgelehnt. Es entsteht kein Ticket.',
  'approvals.requestedBy': 'Beantragt von',
  'cart.approver': 'Freigabe durch',
  'cart.approverHint': 'Ihre vorgesetzte Person. Ohne deren Freigabe entsteht kein Ticket – sie wird benachrichtigt, sobald Sie absenden.',
  'cart.approverSearch': 'Name oder E-Mail eingeben …',
  'cart.approverSuggested': 'Vorschlag aus dem Verzeichnis',
  'cart.approverMissing': 'Bitte wählen Sie die freigebende Person aus.',
  'cart.approverNoResults': 'Keine Person gefunden.',
  'cart.noApprovalNeeded': 'Sie sind freigabeberechtigt – diese Bestellung geht ohne weitere Freigabe an die IT.',
  'nav.approvals': 'Freigaben',
  'request.sentAwaitingApproval': 'Sie liegt jetzt bei {approver} zur Freigabe. Erst danach entsteht ein Ticket bei der IT.',
  'requests.cancel': 'Zurückziehen',
  'requests.cancelled': 'Die Anfrage wurde zurückgezogen.',
  'requests.ticket': 'Ticket',
  'requests.table.created': 'Angefragt am',
  'requests.table.items': 'Positionen',
  'requests.table.requester': 'Person',
  'requests.table.status': 'Stand',
  'requests.admin.title': 'Kataloganfragen',
  'requests.admin.description': 'Alle Anfragen aus dem Katalog. Hier steht auch, wenn aus einer Anfrage noch kein Ticket geworden ist – diese Zeilen brauchen eine Hand.',
  'requests.admin.empty': 'Es gibt noch keine Anfragen.',
  'requests.admin.emptyHint': 'Sobald jemand im Katalog einen Warenkorb absendet, erscheint die Anfrage hier.',
  'requests.admin.retry': 'Ticket erneut anlegen',
  'requests.admin.retried': 'Ticket {ticket} wurde angelegt.',
  'requests.admin.assessQueued': 'Die Vorprüfung läuft im Hintergrund und dauert etwa eine Minute. Fehlt noch das Ticket, wird es danach angelegt.',
  'requests.admin.retryFailed': 'Es hat wieder nicht geklappt: {reason}',
  'requests.admin.openFailures': '{count} Anfragen ohne Ticket',
  'requests.admin.openFailuresHint': 'Diese Anfragen sind gespeichert, aber noch nicht im Helpdesk angekommen.',
  'requests.admin.attempts': '{count} Versuche',
  'requests.admin.filterStatus': 'Stand',
  'nav.sync': 'Synchronisierung',
  'nav.admin': 'Administration',
  'nav.audit': 'Audit-Log',

  'auth.signIn': 'Anmelden',
  'auth.signOut': 'Abmelden',
  'auth.signInPrompt': 'Bitte melden Sie sich mit Ihrem Geschäftskonto an.',
  'auth.vendorNote': 'Eine KI-gestützte Anwendung der Krannich Group',
  'auth.signInHint': 'Es sind ausschließlich Geschäfts- oder Schulkonten dieses Tenants zugelassen.',
  'auth.signingIn': 'Anmeldung läuft …',
  'auth.noRole': 'Ihrem Konto ist keine Rolle in dieser Anwendung zugewiesen.',
  'auth.noRoleHint': 'Bitte wenden Sie sich an die IT-Administration, um eine Rolle zugewiesen zu bekommen.',
  'auth.sessionExpired': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',

  'common.loading': 'Daten werden geladen …',
  'common.error': 'Fehler',
  'common.retry': 'Erneut versuchen',
  'common.refresh': 'Aktualisieren',
  'common.export': 'Exportieren',
  'common.exportCsv': 'Als CSV exportieren',
  'common.search': 'Suchen',
  'common.reportIssuePrefix': 'Stimmt etwas nicht, melden Sie es bitte über das',
  'common.ticketSystem': 'Ticketsystem',
  'assets.field.assignedAt': 'Ausgegeben am',
  'assets.admin.assignedAtHint': 'Leer, solange weder das Quellsystem noch AudIT den Zeitpunkt kennt.',
  'filter.placeholder': 'Filtern …',
  'filter.forColumn': 'Spalte {column} filtern',
  'filter.clearAll': 'Alle Spaltenfilter zurücksetzen',
  'filter.noMatch': 'Kein Eintrag passt zu den Spaltenfiltern.',
  'filter.matches': '{count} von {total} durch Spaltenfilter',
  'filter.truncated': 'Es werden die ersten {count} Zeilen gefiltert – für den vollständigen Bestand den CSV-Export verwenden.',
  'common.filter': 'Filter',
  'common.all': 'Alle',
  'common.none': 'Keine',
  'common.unknown': 'Unbekannt',
  'common.yes': 'Ja',
  'common.no': 'Nein',
  'common.save': 'Speichern',
  'common.cancel': 'Abbrechen',
  'common.delete': 'Löschen',
  'common.edit': 'Bearbeiten',
  'common.create': 'Anlegen',
  'common.close': 'Schließen',
  'common.noData': 'Es liegen noch keine Daten vor.',
  'common.noDataHint': 'Starten Sie eine Synchronisierung, um Lizenzdaten zu laden.',
  'common.total': 'Gesamt',
  'common.rowsShown': '{count} von {total} Einträgen',
  'common.page': 'Seite',
  'common.next': 'Weiter',
  'common.previous': 'Zurück',
  'common.lastUpdate': 'Stand',
  'common.never': 'Nie',
  'common.accessDenied': 'Keine Berechtigung',
  'common.accessDeniedHint': 'Ihre Rolle erlaubt den Zugriff auf diesen Bereich nicht.',
  'common.notFound': 'Seite nicht gefunden',

  'dashboard.title': 'Lizenzübersicht',
  'dashboard.totalUnits': 'Lizenzen gesamt',
  'dashboard.totalUnitsHint': 'Gekaufte und aktive Einheiten',
  'dashboard.assignedUnits': 'Vergeben',
  'dashboard.assignedUnitsHint': 'Aktuell zugewiesene Einheiten',
  'dashboard.availableUnits': 'Frei',
  'dashboard.availableUnitsHint': 'Nicht zugewiesene Einheiten',
  'dashboard.unusedUnits': 'Nicht genutzt',
  'dashboard.unusedUnitsHint': 'Vergeben an deaktivierte Konten',
  'dashboard.utilization': 'Auslastung',
  'dashboard.byProduct': 'Lizenzen je Produkt',
  'dashboard.distribution': 'Verteilung vergeben / frei',
  'dashboard.trend': 'Entwicklung',
  'dashboard.trendDays': 'Zeitraum',
  'dashboard.table.product': 'Produkt',
  'dashboard.table.source': 'Quelle',
  'dashboard.table.total': 'Gesamt',
  'dashboard.table.assigned': 'Vergeben',
  'dashboard.table.available': 'Frei',
  'dashboard.table.disabled': 'Deaktivierte Konten',
  'dashboard.table.inactive': 'Inaktive Konten',
  'dashboard.table.utilization': 'Auslastung',

  'countries.title': 'Länderreport',
  'countries.description': 'Vergebene Lizenzen je Land, ermittelt aus dem Nutzungsstandort der Konten.',
  'countries.table.country': 'Land',
  'countries.table.code': 'Code',
  'countries.table.assigned': 'Vergeben',
  'countries.table.enabled': 'Aktive Konten',
  'countries.table.disabled': 'Deaktivierte Konten',
  'countries.table.products': 'Produkte',
  'countries.chartTitle': 'Vergebene Lizenzen je Land',
  'countries.filterProduct': 'Produkt',
  'countries.unknownHint': 'Konten ohne hinterlegten Nutzungsstandort werden unter „Unbekannt“ geführt.',

  'assignments.title': 'Lizenzzuweisungen',
  'assignments.description': 'Detailansicht aller aktuell vergebenen Lizenzen.',
  'assignments.searchPlaceholder': 'Name, Anmeldename, E-Mail oder Abteilung',
  'assignments.statusActive': 'Nur aktive Konten',
  'assignments.statusDisabled': 'Nur deaktivierte Konten',
  'assignments.resetFilters': 'Filter zurücksetzen',
  'assignments.filteredByName': 'über das Namensfeld',
  'assignments.groupByPerson': 'Eine Zeile je Person',
  'assignments.table.name': 'Name',
  'assignments.table.upn': 'Anmeldename',
  'assignments.productFilterPlaceholder': 'Filtern … („genau“ in Anführungszeichen)',
  'assignments.productFilterHint': 'Ohne Anführungszeichen: enthält. In Anführungszeichen: genau dieser Name – z. B. "Microsoft 365 Copilot" ohne den kostenlosen Copilot Chat.',
  'assignments.table.product': 'Produkt',
  'assignments.table.country': 'Land',
  'assignments.table.department': 'Abteilung',
  'assignments.table.enabled': 'Konto aktiv',
  'assignments.table.source': 'Zuweisung',
  'assignments.table.lastSignIn': 'Letzte Anmeldung',
  'assignments.source.direct': 'Direkt',
  'assignments.source.group': 'Gruppe',
  'assignments.source.unknown': 'Unbekannt',

  'sync.title': 'Synchronisierung',
  'sync.description': 'Die Lizenzdaten werden täglich automatisch aktualisiert und können jederzeit manuell angestoßen werden.',
  'sync.trigger': 'Jetzt synchronisieren',
  'sync.triggering': 'Synchronisierung wird gestartet …',
  'sync.started': 'Die Synchronisierung wurde gestartet und läuft im Hintergrund weiter.',
  'sync.running': 'Synchronisierung läuft',
  'sync.runningHint': 'Sie können diese Seite verlassen; der Vorgang läuft serverseitig weiter.',
  'sync.schedule': 'Zeitplan',
  'sync.lastRun': 'Letzter Lauf',
  'sync.history': 'Verlauf',
  'sync.table.started': 'Gestartet',
  'sync.table.duration': 'Dauer',
  'sync.table.trigger': 'Auslöser',
  'sync.table.status': 'Status',
  'sync.table.source': 'Quelle',
  'sync.table.skus': 'Produkte',
  'sync.table.accounts': 'Konten',
  'sync.table.assignments': 'Zuweisungen',
  'sync.table.triggeredBy': 'Ausgelöst von',
  'sync.trigger.SCHEDULED': 'Zeitplan',
  'sync.trigger.MANUAL': 'Manuell',
  'sync.trigger.BACKFILL': 'Nachtrag',
  'sync.trigger.INGEST': 'Eingeliefert',
  'sync.status.RUNNING': 'Läuft',
  'sync.status.SUCCEEDED': 'Erfolgreich',
  'sync.status.FAILED': 'Fehlgeschlagen',
  'sync.status.PARTIAL': 'Mit Hinweisen',
  'sync.status.CANCELLED': 'Abgebrochen',
  'sync.warnings': 'Hinweise',
  'sync.log': 'Protokoll',
  'sync.logHint': 'Abschnitte des ausgewählten Laufs. Während eines laufenden Abgleichs aktualisiert sich die Liste automatisch.',
  'sync.logEmpty': 'Für diesen Lauf liegen noch keine Abschnitte vor.',
  'sync.logSelect': 'Lauf im Verlauf anklicken, um dessen Protokoll zu sehen.',
  'sync.logOf': 'Lauf vom {time}',
  'sync.elapsed': 'Läuft seit',
  'sync.level.INFO': 'Info',
  'sync.level.WARN': 'Hinweis',
  'sync.level.ERROR': 'Fehler',

  'admin.title': 'Administration',
  'admin.sources': 'Lizenzquellen',
  'admin.sourcesDescription': 'Konfigurierte SaaS-Anbieter, aus denen Lizenzdaten gelesen werden.',
  'admin.setupSteps': 'Einrichtung',
  'admin.setupDocs': 'Ausführliche Anleitung öffnen',
  'admin.availableConnectors': 'Verfügbare Anbindungen',
  'admin.connectorsDescription': 'Alle Anbindungen, die dieses System kennt – mit Einrichtungsschritten und benötigten Berechtigungen. Eine Lizenzquelle entsteht daraus unter „Lizenzquellen“.',
  'admin.addSource': 'Lizenzquelle hinzufügen',
  'admin.editSource': 'Lizenzquelle bearbeiten',
  'admin.testConnection': 'Verbindung testen',
  'admin.testSuccess': 'Verbindung erfolgreich.',
  'admin.testFailed': 'Verbindung fehlgeschlagen.',
  'admin.deleteConfirmTitle': 'Lizenzquelle löschen?',
  'admin.deleteConfirmBody':
    'Damit werden auch alle gespeicherten Lizenzstände und die vollständige Historie dieser Quelle unwiderruflich gelöscht.',
  'admin.field.connector': 'Anbindung',
  'admin.field.slug': 'Technische Kennung',
  'admin.field.slugHint': 'Kleinbuchstaben, Ziffern und Bindestriche. Nach dem Anlegen nicht mehr änderbar.',
  'admin.field.displayName': 'Anzeigename',
  'admin.field.description': 'Beschreibung',
  'admin.field.enabled': 'Aktiv',
  'admin.table.name': 'Name',
  'admin.table.connector': 'Anbindung',
  'admin.table.status': 'Status',
  'admin.table.lastSync': 'Letzte Synchronisierung',
  'admin.table.actions': 'Aktionen',
  'admin.connector.available': 'Verfügbar',
  'admin.connector.preview': 'Vorschau',
  'admin.connector.planned': 'Geplant',
  'admin.requiredPermissions': 'Benötigte Berechtigungen',
  'admin.secretHint':
    'Diese Konfiguration ist für alle Lesenden sichtbar. Tragen Sie hier kein Geheimnis ein, sondern eine Referenz im Format „env:<NAME>“ auf eine Anwendungseinstellung. Bei Quellen vom Typ „Push“ verwalten Sie die Zugangsdaten in n8n.',

  'audit.title': 'Audit-Log',
  'audit.description': 'Protokoll aller administrativen Aktionen und Synchronisierungen.',
  'audit.table.time': 'Zeitpunkt',
  'audit.table.actor': 'Benutzer',
  'audit.table.action': 'Aktion',
  'audit.table.target': 'Objekt',
  'audit.table.outcome': 'Ergebnis',
  'audit.table.details': 'Details',
  'audit.outcome.SUCCESS': 'Erfolgreich',
  'audit.outcome.FAILURE': 'Fehlgeschlagen',
  'audit.outcome.DENIED': 'Abgelehnt',
  'audit.filterAction': 'Aktion',
  'audit.filterFrom': 'Von',
  'audit.filterTo': 'Bis',

  'dashboard.includeDisabled': 'Deaktivierte Konten einbeziehen',
  'dashboard.excludedDisabled': '{count} Einheiten an deaktivierten Konten herausgerechnet – Microsoft berechnet sie weiter, solange die Lizenz zugewiesen ist.',
  'dashboard.includeFree': 'Kostenlose Lizenzen einbeziehen',
  'dashboard.hiddenFree': '{count} kostenlose Produkte ausgeblendet – über den Schalter einbeziehbar',
  'dashboard.costAssigned': 'Kosten vergeben / Monat',
  'dashboard.costAssignedHint': 'Vergebene Einheiten × Monatspreis',
  'dashboard.costAvailable': 'Kosten frei / Monat',
  'dashboard.costAvailableHint': 'Bezahlt, aber nicht vergeben',
  'dashboard.costUnused': 'Kosten deaktivierte Konten / Monat',
  'dashboard.costUnusedHint': 'Vergeben an deaktivierte Konten – Einsparpotenzial',
  'dashboard.unpriced': '{count} bezahlte Produkte ohne Preis – die Kostensummen sind unvollständig.',
  'dashboard.mixedCurrencies': 'Preise in unterschiedlichen Währungen – die Summen sind nicht vergleichbar.',
  'dashboard.noPrices': 'Noch keine Preise hinterlegt. Preise pflegen Sie unter Administration → Produkte und Preise.',
  'dashboard.table.unitCost': 'Preis/Monat',
  'dashboard.table.cost': 'Kosten/Monat',
  'dashboard.table.free': 'kostenlos',
  'dashboard.table.noPrice': 'kein Preis',

  'countries.table.cost': 'Kosten/Monat',
  'countries.unpricedShort': '{count} ohne Preis',

  'admin.prices': 'Produkte und Preise',
  'admin.pricesDescription': 'Monatspreis je Einheit für das Kostencontrolling. Kostenlose Produkte zählen nicht in die Kosten und lassen sich in den Auswertungen ausblenden.',
  'admin.prices.netDisclaimer': 'Alle Preise netto eintragen – ohne Umsatzsteuer, so wie sie auf der Rechnung als Nettobetrag stehen. Die Kostenauswertungen sind damit ebenfalls Nettowerte.',
  'admin.prices.hint': 'Jahresverträge als Monatsäquivalent eintragen. Leer bedeutet „kein Preis“ – die Kosten gelten dann als unbekannt, nicht als null.',
  'admin.prices.onlyUnpriced': 'Nur ohne Preis',
  'admin.prices.showRetired': 'Ausgelaufene anzeigen',
  'admin.prices.saved': 'Preis gespeichert.',
  'admin.prices.table.product': 'Produkt',
  'admin.prices.table.source': 'Quelle',
  'admin.prices.table.total': 'Gekauft',
  'admin.prices.table.assigned': 'Vergeben',
  'admin.prices.table.free': 'Kostenlos',
  'admin.prices.table.unitCost': 'Preis je Einheit / Monat',
  'admin.prices.table.currency': 'Währung',
  'admin.prices.table.updated': 'Zuletzt geändert',
  'admin.prices.retired': 'ausgelaufen',
  'admin.prices.emptyProvider': 'Für diese Lizenzquelle liegt noch kein Lauf vor. Produkte erscheinen nach der ersten Synchronisierung; manuell gepflegte Quellen werden beim Speichern sofort übernommen.',
  'admin.checkItems': 'Positionen prüfen',
  'admin.savedAndSynced': 'Lizenzquelle gespeichert und synchronisiert – die Positionen stehen unter „Produkte und Preise“.',
  'admin.savedSyncFailed': 'Lizenzquelle gespeichert, der Lauf ist aber fehlgeschlagen: {error}',
  'category.productivity': 'Produktivität',
  'category.security': 'Sicherheit',
  'category.communication': 'Kommunikation',
  'category.infrastructure': 'Infrastruktur',
  'category.erp': 'ERP / Finanzen',
  'category.data': 'Daten & Analyse',
  'category.ai': 'KI/Automatisierung',
  'category.development': 'Entwicklung',
  'category.creative': 'Kreativ / Design',
  'category.other': 'Sonstiges',
  'category.none': 'ohne Kategorie',
  'admin.prices.table.category': 'Kategorie',
  'admin.manual.category': 'Kategorie',
  'admin.manual.categoryHint': 'Für die Kostensicht nach Kategorie, z. B. Sicherheit für CrowdStrike.',
  'dashboard.costByCategory': 'Kosten nach Kategorie',
  'dashboard.bySource': 'Je Lizenzquelle',
  'dashboard.source.hint': '{assigned} vergeben',
  'dashboard.source.hintCost': '{assigned} vergeben · {cost} / Monat',
  'dashboard.action.source': 'Produkte dieser Lizenzquelle zeigen',
  'dashboard.action.allProducts': 'Alle Produkte in der Tabelle unten zeigen',
  'dashboard.action.assignments': 'Zu den Zuweisungen aktiver Konten',
  'dashboard.action.available': 'Produkte mit freien Einheiten zeigen',
  'dashboard.action.disabled': 'Zuweisungen an deaktivierte Konten zeigen',
  'dashboard.action.lowUtilization': 'Produkte unter 80 % Auslastung zeigen',
  'dashboard.action.people': 'Kosten je Person zeigen',
  'dashboard.action.shared': 'Gemeinkosten-Produkte zeigen',
  'dashboard.action.countries': 'Kosten je Land mit Umlage zeigen',
  'dashboard.action.category': 'Produkte dieser Kategorie zeigen',
  'dashboard.action.product': 'Zuweisungen dieses Produkts zeigen',
  'dashboard.action.showUnpriced': 'Produkte ohne Preis zeigen',
  'dashboard.focus.available': 'mit freien Einheiten',
  'dashboard.focus.lowUtilization': 'unter 80 % Auslastung',
  'dashboard.focus.shared': 'Gemeinkosten',
  'dashboard.focus.unpriced': 'ohne Preis',
  'dashboard.focus.empty': 'Kein Produkt passt zu diesem Filter.',
  'dashboard.focus.reset': 'Filter „{filter}“ entfernen',
  'dashboard.table.category': 'Kategorie',
  'dashboard.table.products': 'Produkte',
  'dashboard.table.share': 'Anteil',
  'admin.members.pasteLabel': 'Liste einfügen',
  'admin.members.pasteHint': 'In claude.ai unter „Organisationseinstellungen → Mitglieder“ die Liste markieren, kopieren und hier einfügen. Name und Adresse werden automatisch getrennt; Zeilen ohne Adresse werden übersprungen.',
  'admin.members.pastePlaceholder': 'Alexis Ladas  a.ladas@example.com\nBea Beispiel  b.beispiel@example.com',
  'admin.members.pasteApply': 'Übernehmen',
  'admin.members.importFile': 'CSV-Datei importieren',
  'admin.members.importHint': 'Der Import ersetzt die Liste – ein Export ist der vollständige Stand.',
  'admin.members.importedAt': 'Zuletzt importiert: {date}',
  'admin.members.importResult': '„{file}“: {count} Personen übernommen, Liste ersetzt (vorher {before}). {skipped} Zeilen ohne Adresse, {removed} entfernte Zugänge übersprungen. Zum Übernehmen speichern.',
  'admin.members.importEmpty': '„{file}“ enthält keine erkennbare E-Mail-Adresse. Die Liste bleibt unverändert.',
  'admin.members.importFailed': '„{file}“ ließ sich nicht lesen. Die Liste bleibt unverändert.',
  'admin.members.pasteResult': '{added} neu, {known} bereits vorhanden, {skipped} Zeilen ohne Adresse übersprungen.',
  'admin.members.tableLabel': 'Mitglieder',
  'admin.members.name': 'Name',
  'admin.members.namePlaceholder': 'optional',
  'admin.members.email': 'E-Mail-Adresse',
  'admin.members.duplicate': 'Adresse kommt mehrfach vor',
  'admin.members.duplicatesHint': 'Doppelte Adressen werden beim Speichern abgewiesen.',
  'admin.members.empty': 'Noch keine Mitglieder. Liste oben einfügen oder Zeilen einzeln anlegen.',
  'admin.members.add': 'Zeile hinzufügen',
  'admin.members.count': '{count} Personen',
  'admin.seatGroups.tableLabel': 'Sitzplatzgruppen',
  'admin.seatGroups.groupId': 'Objekt-Id der Entra-Gruppe',
  'admin.seatGroups.name': 'Produktname',
  'admin.seatGroups.namePlaceholder': 'leer = „Claude – Gruppenname“',
  'admin.seatGroups.seats': 'Gebuchte Plätze',
  'admin.seatGroups.seatsPlaceholder': 'leer = Benutzerzahl',
  'admin.seatGroups.invalidGuid': 'Keine GUID',
  'admin.seatGroups.duplicate': 'Gruppe kommt mehrfach vor',
  'admin.seatGroups.add': 'Gruppe hinzufügen',
  'admin.seatGroups.empty': 'Noch keine Gruppe. Je Sitzplatzstufe (z. B. Standard, Premium) eine Entra-Gruppe eintragen.',
  'admin.seatGroups.orderHint': 'Reihenfolge = Vorrang: Steht eine Person in mehreren Gruppen, zählt sie nur in der obersten. Die teurere Stufe deshalb nach oben.',
  'admin.seatGroups.moveUp': 'Nach oben',
  'admin.seatGroups.moveDown': 'Nach unten',
  'admin.seatGroups.count': '{count} Gruppen',
  'admin.manual.title': 'Manuell gepflegte Positionen',
  'admin.manual.name': 'Vertrag / Lizenz',
  'admin.manual.namePlaceholder': 'z. B. Sage (Gruppenvertrag)',
  'admin.manual.units': 'Menge',
  'admin.manual.annualCost': 'Jahresbetrag netto',
  'admin.manual.currency': 'Währung',
  'admin.manual.countries': 'Umlage auf',
  'admin.manual.allCountries': 'alle Länder',
  'admin.manual.addCountry': 'Land',
  'admin.manual.note': 'Notiz',
  'admin.manual.add': 'Position hinzufügen',
  'admin.manual.empty': 'Noch keine Position. Jede Zeile wird beim Lauf zu einem Produkt mit fester Menge.',
  'admin.manual.hint': 'Jahresbetrag für alle Einheiten, netto. Daraus wird der Monatspreis je Einheit vorbelegt; Änderungen unter „Produkte und Preise“ gewinnen dauerhaft.',
  'admin.manual.monthlyHint': '= {amount} je Einheit und Monat',
  'admin.manual.newItem': 'Position {index}',
  'admin.manual.idHint': 'Technische Kennung: {id} – bleibt nach dem Speichern fest.',
  'admin.manual.countriesHint': 'Leer = alle Länder. Fehlt ein Land in der Auswahl, als zweistelligen Code ergänzen.',
  'admin.prices.table.countries': 'Umlage auf',
  'admin.prices.countries.all': 'alle Länder',
  'admin.prices.countriesHint': 'Länder, auf die die Gemeinkosten dieses Produkts umgelegt werden. Leer = alle Länder. Bei einer manuell gepflegten Lizenzquelle gilt die Konfiguration der Quelle.',
  'admin.prices.table.shared': 'Gemeinkosten',
  'admin.prices.sharedHint': 'Gemeinkosten: nicht zuweisbar (z. B. Dataverse-Kapazität, Serverlizenzen). Der ganze Bestand gilt als verbraucht; die Kosten werden im Länderreport per Umlageschlüssel auf die Länder verteilt.',
  'dashboard.costShared': 'Gemeinkosten / Monat',
  'dashboard.costSharedHint': 'Nicht zuweisbare Produkte, Bestand × Preis – werden im Länderreport umgelegt',
  'dashboard.costTotal': 'Gesamtkosten / Monat',
  'dashboard.costTotalHint': 'Vergeben plus Gemeinkosten',
  'dashboard.sharedBadge': 'Gemeinkosten',
  'dashboard.sharedSkus': '{count} Produkte sind Gemeinkosten: je Produkt voll vergeben, aber nicht in den Stückzahlen oben – ihre Kosten stehen unter „Gemeinkosten“ und werden im Länderreport umgelegt.',
  'countries.table.heads': 'Personen',
  'countries.table.directCost': 'Direkte Kosten/Monat',
  'countries.table.allocated': 'Umlage/Monat',
  'countries.table.total': 'Gesamt/Monat',
  'countries.allocationKey': 'Umlage nach',
  'countries.allocationKey.heads': 'Personen mit Lizenz',
  'countries.allocationKey.directCost': 'direkten Kosten',
  'countries.sharedPool': 'Gemeinkosten-Topf',
  'countries.sharedPoolDescription': 'Nicht zuweisbare Produkte, bewertet mit Bestand × Preis. Der Topf wird nach dem gewählten Schlüssel auf die Länder verteilt; die Summe der Umlagen entspricht dem Topf.',
  'countries.sharedPoolUnpriced': '{count} Produkte im Topf ohne Preis – so viel fehlt in der Umlage.',
  'countries.sharedPoolEmpty': 'Keine Gemeinkosten-Produkte. Produkte lassen sich unter Administration → Produkte und Preise als Gemeinkosten kennzeichnen.',
  'countries.sharedPoolUnallocated': 'Der Topf konnte nicht verteilt werden: Der Umlageschlüssel ist in allen Ländern 0.',
  'countries.sharePercent': '{percent} % Anteil',
  'admin.prices.connector': 'Lizenzquelle',
  'admin.prices.connector.all': 'Alle Lizenzquellen',
  'admin.prices.connectorHint': 'Preise gelten je Lizenzquelle: Dasselbe Produkt kann in einem anderen Tenant einen anderen Preis haben.',
  'admin.prices.table.costItems': 'Bezugswege',
  'admin.prices.derived': 'abgeleitet',
  'admin.prices.derivedHint': 'Der Preis ergibt sich aus den Kostenpositionen (mengengewichtet) und wird deshalb nicht direkt bearbeitet.',
  'admin.prices.uncovered': '{units} Einheiten ohne Position',
  'admin.prices.mixedCurrencies': 'Verschiedene Währungen – kein gemeinsamer Preis.',
  'admin.prices.costItems': 'Kostenpositionen',
  'admin.prices.costItems.open': 'Bezugswege',
  'admin.prices.costItems.description': 'Ein Eintrag je Bezugsweg – zum Beispiel Microsoft EA über Bechtle, Vodafone oder Direktkauf. Der wirksame Preis ist der mengengewichtete Mittelwert.',
  'admin.prices.costItems.none': 'Noch keine Position. Ohne Positionen wird der Preis direkt am Produkt gepflegt.',
  'admin.prices.costItems.add': 'Position hinzufügen',
  'admin.prices.costItems.source': 'Bezugsquelle',
  'admin.prices.costItems.contractRef': 'Vertrag / Bestellnummer',
  'admin.prices.costItems.units': 'Menge',
  'admin.prices.costItems.unitsRest': 'übrige',
  'admin.prices.costItems.unitsHint': 'Leer bedeutet „alle übrigen Einheiten“ – nur einmal möglich.',
  'admin.prices.costItems.unitCost': 'Preis je Einheit / Monat',
  'admin.prices.costItems.currency': 'Währung',
  'admin.prices.costItems.validFrom': 'Gültig ab',
  'admin.prices.costItems.validTo': 'Gültig bis',
  'admin.prices.costItems.note': 'Notiz',
  'admin.prices.costItems.expired': 'nicht aktiv',
  'admin.prices.costItems.contracted': 'Vertragskosten je Monat',
  'admin.prices.costItems.effective': 'Wirksamer Preis',
  'admin.prices.costItems.saved': 'Kostenposition gespeichert.',
  'admin.prices.costItems.deleted': 'Kostenposition entfernt.',
  'admin.prices.costItems.confirmDelete': 'Diese Kostenposition entfernen?',

  'people.title': 'Kosten je Person',
  'people.description': 'Alle Lizenzen und zugeordneten Geräte einer Person über sämtliche Quellen, zusammengeführt über die E-Mail-Adresse. Lizenzkosten sind monatlich, der Hardwarewert ist der einmalige Anschaffungspreis – die beiden werden bewusst nicht verrechnet.',
  'people.searchPlaceholder': 'Name, E-Mail, Anmeldename oder Abteilung',
  'people.onlyPriced': 'Nur mit bekannten Kosten',
  'people.table.name': 'Person',
  'people.table.country': 'Land',
  'people.table.department': 'Abteilung',
  'people.table.sources': 'Quellen',
  'people.table.licenses': 'Lizenzen',
  'people.table.cost': 'Kosten/Monat',
  'people.unpriced': '{count} ohne Preis',
  'people.totals': '{count} Personen · {cost} pro Monat (bekannte Preise)',
  'people.totalsUnpriced': '{count} Personen mit Lizenzen ohne Preis',
  'people.disabled': 'Konto deaktiviert',
  'people.table.devices': 'Geräte',
  'people.table.hardware': 'Hardware (Anschaffung)',
  'people.showSoftware': 'Softwarekosten anzeigen',
  'people.showHardware': 'Hardwarekosten anzeigen',
  'people.unpricedDevices': '{count} ohne Preis',
  'people.totalsHardware': '{cost} Anschaffungswert (einmalig, {count} Geräte)',
  'people.totalsPeople': '{count} Personen',
  'people.hardwareHint': 'Einmaliger Anschaffungswert – nicht monatlich.',

  'role.LicenseAdmin': 'Administration',
  'role.LicenseOperator': 'Bearbeitung',
  'role.LicenseReader': 'Lesezugriff',
  'role.LicenseIngest': 'Datenlieferung (System)',
  'role.CatalogReader': 'IT-Katalog (Lesezugriff)',

  'error.network': 'Der Server ist nicht erreichbar. Bitte versuchen Sie es später erneut.',
  'error.unauthorized': 'Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.',
  'error.forbidden': 'Ihre Rolle erlaubt diese Aktion nicht.',
  'error.conflict': 'Die Aktion steht im Konflikt mit dem aktuellen Zustand.',
  'error.unexpected': 'Es ist ein unerwarteter Fehler aufgetreten.',
  'error.correlationId': 'Referenz-Nr. für den Support',
  'error.correlationIdLocal': 'Lokale Referenz-Nr. (der Server hat keine gemeldet)',
  'nav.catalog': 'IT-Katalog',
  'nav.opensInNewTab': 'Öffnet in einem neuen Tab',
  'catalog.toLicenseManagement': 'Zum Lizenzmanagement',
  'catalog.hardware': 'Hardware',
  'catalog.software': 'Software',
  'catalog.title': 'IT-Katalog',
  'catalog.description': 'Von der IT unterstützte Hardware und Software. Was hier steht, darf bestellt werden.',
  'catalog.search': 'Nach Produkt, Hersteller oder Modell suchen',
  'catalog.filter.category': 'Kategorie',
  'catalog.filter.manufacturer': 'Hersteller',
  'catalog.filter.support': 'Unterstützung',
  'catalog.filter.all': 'Alle',
  'catalog.filter.reset': 'Filter zurücksetzen',
  'catalog.empty': 'Zu dieser Auswahl gibt es keine Einträge.',
  'catalog.emptyHint': 'Andere Kategorie wählen oder die Suche zurücksetzen.',
  'catalog.count.one': '1 Eintrag',
  'catalog.count.other': '{count} Einträge',
  'catalog.details': 'Details',
  'catalog.order': 'Bestellen',
  'catalog.orderNote': 'Bestellhinweis',
  'catalog.price': 'Preis',
  'catalog.priceHint': 'Netto-Listenpreis für die Bestellung. Leer lassen, wenn unbekannt – leer heißt nicht kostenlos.',
  'catalog.priceInterval': 'Abrechnung',
  'catalog.priceInterval.ONE_TIME': 'einmalig',
  'catalog.priceInterval.MONTHLY': 'pro Monat',
  'catalog.priceInterval.YEARLY': 'pro Jahr',
  'catalog.priceUnknown': 'Preis auf Anfrage',
  'catalog.specifications': 'Technische Daten',
  'catalog.operatingSystems': 'Betriebssysteme',
  'catalog.intendedUse': 'Einsatzzweck',
  'catalog.audience': 'Zielgruppe',
  'catalog.manufacturer': 'Hersteller',
  'catalog.model': 'Modell / Artikelnummer',
  'catalog.modelSoftware': 'Version / Edition',
  'catalog.updatedAt': 'Zuletzt geändert am {date}',
  'catalog.support.STANDARD': 'Standard',
  'catalog.support.SUPPORTED': 'Unterstützt',
  'catalog.support.LIMITED': 'Eingeschränkt unterstützt',
  'catalog.support.PHASE_OUT': 'Auslaufmodell',
  'catalog.support.NOT_ORDERABLE': 'Nicht mehr bestellbar',
  'catalog.publish.DRAFT': 'Entwurf',
  'catalog.publish.PUBLISHED': 'Veröffentlicht',
  'catalog.publish.ARCHIVED': 'Archiviert',
  'catalog.notOrderableHint': 'Dieses Produkt kann nicht mehr bestellt werden. Es steht hier, damit vorhandene Geräte zuordenbar bleiben.',
  'catalog.limitedHint': 'Eingeschränkt unterstützt – bitte vor der Bestellung mit der IT abstimmen.',
  'catalog.admin.title': 'Katalog verwalten',
  'catalog.admin.description': 'Einträge anlegen, bearbeiten, veröffentlichen und archivieren.',
  'catalog.admin.categories': 'Kategorien',
  'catalog.admin.categoriesDescription': 'Kategorien des Katalogs – je Zweig eigene Kategorien, Reihenfolge frei wählbar.',
  'catalog.admin.newItem': 'Eintrag hinzufügen',
  'catalog.admin.newCategory': 'Kategorie hinzufügen',
  'catalog.admin.editItem': 'Eintrag bearbeiten',
  'catalog.admin.editCategory': 'Kategorie bearbeiten',
  'catalog.admin.preview': 'Vorschau',
  'catalog.admin.previewHint': 'So sehen Mitarbeitende den Eintrag nach der Veröffentlichung.',
  'catalog.admin.saveDraft': 'Als Entwurf speichern',
  'catalog.admin.publish': 'Veröffentlichen',
  'catalog.admin.archive': 'Archivieren',
  'catalog.admin.unarchive': 'Wieder veröffentlichen',
  'catalog.admin.deleteForever': 'Endgültig löschen',
  'catalog.admin.deleteCategoryConfirm': 'Kategorie „{name}“ endgültig löschen? Das ist nur möglich, solange sie keine Einträge enthält.',
  'catalog.admin.archiveConfirm': '„{name}“ archivieren? Der Eintrag verschwindet aus dem Katalog, bleibt aber erhalten.',
  'catalog.admin.saved': 'Gespeichert.',
  'catalog.admin.filterStatus': 'Status',
  'catalog.admin.image': 'Bild',
  'catalog.admin.imageUpload': 'Bild auswählen',
  'catalog.admin.imageRemove': 'Bild entfernen',
  'catalog.admin.imageHint': 'PNG, JPEG oder WebP, höchstens 2 MB. SVG ist aus Sicherheitsgründen nicht zulässig.',
  'catalog.admin.imageTooLarge': 'Das Bild ist zu groß. Zulässig sind höchstens 2 MB.',
  'catalog.admin.german': 'Deutsch',
  'catalog.admin.english': 'Englisch',
  'catalog.admin.englishHint': 'Optional. Bleibt das Feld leer, zeigt der englische Katalog den deutschen Text.',
  'catalog.admin.missingEnglish': 'Englische Fassung unvollständig',
  'catalog.admin.kind': 'Zweig',
  'catalog.admin.name': 'Produktname',
  'catalog.admin.shortDescription': 'Kurzbeschreibung',
  'catalog.admin.longDescription': 'Ausführliche Beschreibung',
  'catalog.admin.orderUrl': 'Link zum Bestellprozess',
  'catalog.admin.orderUrlHint': 'Nur http, https oder mailto.',
  'catalog.admin.orderFieldEnabled': 'Bei der Bestellung eine Zusatzangabe abfragen',
  'catalog.admin.orderFieldEnabledHint': 'Für generische Artikel, die erst mit einer Angabe bestellbar sind – z. B. das Gerätemodell beim Panzerglas. Das Feld erscheint im Warenkorb, der Wert steht im Ticket.',
  'catalog.admin.orderFieldLabel': 'Beschriftung des Feldes',
  'catalog.admin.orderFieldLabelPlaceholder': 'z. B. Gerätemodell',
  'catalog.admin.orderFieldLabelMissing': 'Ohne Beschriftung weiß niemand, was einzutragen ist.',
  'catalog.admin.orderFieldHint': 'Hinweis unter dem Feld',
  'catalog.admin.orderFieldHintPlaceholder': 'z. B. iPhone 15 Pro',
  'catalog.admin.orderFieldRequired': 'Pflichtangabe – ohne sie lässt sich die Anfrage nicht absenden',
  'catalog.admin.sortOrder': 'Sortierung',
  'catalog.admin.sortOrderHint': 'Kleine Zahlen zuerst; bei Gleichstand alphabetisch.',
  'catalog.admin.active': 'Aktiv',
  'catalog.admin.slug': 'Schlüssel',
  'catalog.admin.slugHint': 'Leer lassen – wird aus dem Namen gebildet.',
  'catalog.admin.slugPreview': 'Wird gespeichert als „{slug}“. Groß- und Kleinschreibung sowie Sonderzeichen werden dabei vereinheitlicht.',
  'catalog.admin.specLabel': 'Bezeichnung',
  'catalog.admin.specValue': 'Wert',
  'catalog.admin.specAdd': 'Angabe hinzufügen',
  'catalog.admin.specEmpty': 'Noch keine technischen Daten erfasst.',
  'catalog.admin.osAdd': 'Betriebssystem hinzufügen',
  'catalog.admin.itemCount': 'Einträge',
  'catalog.admin.requiredMissing': 'Bitte Produktname, Hersteller und Kategorie ausfüllen.',
  'nav.assets': 'Geräte',
  'nav.myDevices': 'Meine Geräte',
  'nav.mySoftware': 'Meine Software',
  'licenses.my.title': 'Meine Software',
  'licenses.my.description': 'Die Lizenzen, die Ihren Konten zugewiesen sind – über alle Lizenzquellen hinweg.',
  'licenses.my.empty': 'Ihnen ist derzeit keine Lizenz zugewiesen.',
  'licenses.my.emptyHint': 'Das heißt nicht zwingend, dass Sie keine haben – es kann auch sein, dass Ihr Konto hier unter einer anderen Adresse geführt wird.',
  'licenses.my.emptySearchedFor': 'Gesucht wurde nach {address}.',
  'licenses.my.assignedAt': 'Zugewiesen seit',
  'licenses.my.account': 'Konto',
  'licenses.my.sourceHint': 'Die Zuweisungen stammen aus den angebundenen Lizenzquellen und werden regelmäßig synchronisiert.',
  'catalog.priceIntervalSoftwareHint': 'Software wird im Katalog immer als Jahrespreis geführt.',
  'assets.status.IN_USE': 'In Benutzung',
  'assets.status.IN_STOCK': 'Auf Lager',
  'assets.status.RESERVED': 'Reserviert',
  'assets.status.IN_REPAIR': 'In Reparatur',
  'assets.status.RETIRED': 'Ausgemustert',
  'assets.status.LOST': 'Verlust / Diebstahl',
  'assets.field.name': 'Gerät',
  'assets.field.assetTag': 'Inventarnummer',
  'assets.field.serialNumber': 'Seriennummer',
  'assets.field.deviceType': 'Gerätetyp',
  'assets.field.status': 'Zustand',
  'assets.field.holder': 'Zugeordnet an',
  'assets.field.location': 'Standort',
  'assets.field.costCenter': 'Kostenstelle',
  'assets.field.changedBy': 'Geändert von',
  'assets.field.importedBy': 'Import aus {source}',
  'assets.field.notes': 'Notizen',
  'assets.field.warrantyEnd': 'Garantie bis',
  'assets.field.lastSeen': 'Zuletzt gemeldet',
  'assets.field.purchaseDate': 'Kaufdatum',
  'assets.field.purchaseCost': 'Anschaffung',
  'assets.noPrice': 'kein Preis gepflegt',
  'assets.warrantyExpired': 'Die Garantie ist abgelaufen.',
  'assets.my.title': 'Meine Geräte',
  'assets.my.description': 'Die Geräte, die auf Sie gebucht sind – mit Seriennummer und Inventarnummer für den Fall, dass die IT danach fragt.',
  'assets.my.empty': 'Auf Sie ist derzeit kein Gerät gebucht.',
  'assets.my.emptyHint': 'Das heißt nicht zwingend, dass Sie keines haben – es kann auch sein, dass die Zuordnung im Quellsystem fehlt.',
  'assets.my.emptySearchedFor': 'Gesucht wurde nach {address} – ist das Gerät im Quellsystem auf eine andere Adresse gebucht, fehlt die Verbindung.',
  'assets.my.sourceHint': 'Der Bestand stammt aus der Geräteverwaltung der IT und wird regelmäßig aktualisiert.',
  'assets.admin.title': 'Geräteverwaltung',
  'assets.admin.description': 'Der gesamte Gerätebestand. Gepflegt wird hier, was kein Quellsystem liefert – Zuordnung, Standort und Notizen.',
  'assets.admin.count.one': '1 Gerät',
  'assets.admin.count.other': '{count} Geräte',
  'assets.admin.search': 'Suche',
  'assets.admin.searchPlaceholder': 'Gerät, Seriennummer, Inventarnummer oder Person',
  'assets.admin.empty': 'Zu dieser Auswahl gibt es keine Geräte.',
  'assets.admin.emptyHint': 'Filter zurücksetzen – oder es wurde noch kein Bestand eingeliefert.',
  'assets.admin.kpi.total': 'Geräte gesamt',
  'assets.admin.kpi.unresolved': 'Ohne Zuordnung',
  'assets.admin.kpi.unresolvedHint': 'Ein Besitzer wurde gemeldet, ließ sich aber keiner Person zuordnen.',
  'assets.admin.unresolved': 'nicht zugeordnet',
  'assets.admin.noHolder': 'niemandem zugeordnet',
  'assets.admin.history': 'Verlauf',
  'assets.admin.noHistory': 'Für dieses Gerät ist noch kein Verlauf erfasst.',
  'assets.admin.unknownActor': 'nicht aufgezeichnet',
  'assets.admin.ongoing': 'laufend',
  'assets.admin.saved': 'Gespeichert.',
  'assets.field.collection': 'Kollektion',
  'assets.field.collectionGroup': 'Gruppe',
  'assets.field.composition': 'Zusammensetzung',
  'assets.field.deviceCount': 'Geräte',
  'assets.admin.tab.devices': 'Geräte',
  'assets.admin.tab.collections': 'Kollektionen',
  'assets.admin.includeCollections': 'Geräte aus Kollektionen einbeziehen',
  'assets.admin.includeCollectionsHint': 'Tische und Räume stehen im Reiter „Kollektionen“. Hier nur, wenn Sie eines davon einzeln suchen.',
  'assets.admin.inCollection': 'in Kollektion',
  'assets.admin.kpi.collections': 'Kollektionen',
  'assets.admin.kpi.inCollections': 'Geräte in Kollektionen',
  'assets.admin.kpi.inCollectionsHint': 'Tische, Meetingräume und andere Sammlungen aus dem Quellsystem.',
  'assets.admin.collections.description': 'Tische, Meetingräume und andere Sammlungen aus dem Quellsystem – je Zeile eine Kollektion mit dem, was dazugehört.',
  'assets.admin.collections.count.one': '1 Kollektion',
  'assets.admin.collections.count.other': '{count} Kollektionen',
  'assets.admin.collections.empty': 'Es gibt noch keine Kollektionen.',
  'assets.admin.collections.emptyHint': 'Kollektionen kommen mit der Lieferung aus dem Quellsystem, sobald die Sicht die Spalte „collection“ liefert.',
  'assets.admin.collections.search': 'Kollektion suchen',
  'assets.admin.collections.searchPlaceholder': 'Tisch-0001, Raum Amsel, Standort, Person …',
  'assets.admin.collections.lentTo': 'Ausgeliehen an',
  'assets.admin.collections.notLent': 'nicht ausgeliehen',
  'assets.admin.collections.show': 'Geräte anzeigen',
  'assets.admin.collections.hide': 'Geräte ausblenden',
  'assets.admin.collections.loading': 'Geräte werden geladen …',
  'assets.admin.collections.holderHint': 'Pseudobenutzer aus dem Quellsystem',
  'scan.button': 'Scannen',
  'scan.title': 'Barcode scannen',
  'scan.starting': 'Kamera wird gestartet …',
  'scan.hint': 'Halten Sie das Etikett in den Rahmen. Der Code wird automatisch erkannt.',
  'scan.denied': 'Der Zugriff auf die Kamera wurde verweigert. Erlauben Sie ihn in den Browsereinstellungen – oder nehmen Sie ein Foto auf.',
  'scan.noCamera': 'Auf diesem Gerät steht keine Kamera zur Verfügung. Sie können stattdessen ein Foto des Etiketts aufnehmen oder auswählen.',
  'scan.failed': 'Die Kamera konnte nicht gestartet werden. Versuchen Sie es mit einem Foto.',
  'scan.nothingFound': 'Auf dem Bild wurde kein Barcode erkannt. Näher heran, gerade halten, gutes Licht.',
  'scan.timeout': 'Die Kamera hat kein Bild geliefert. Prüfen Sie die Kameraberechtigung der Website – oder nehmen Sie ein Foto auf.',
  'scan.tapToStart': 'Kamera starten',
  'scan.takePhoto': 'Foto aufnehmen',
  'scan.result': 'Gescannt: {code}',
  'assets.admin.sourceFields': 'Aus Quelle „{source}“ (Kennung {externalId}), zuletzt gemeldet am {lastSeen}. Herkunftsfelder werden von der nächsten Lieferung überschrieben.',
} as const;

export type TranslationKeys = keyof typeof de;
export type TranslationDictionary = Record<TranslationKeys, string>;
